import React, { useEffect, useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label, odal, ModalHeader, ModalBody, ModalFooter, Modal, Button, Input, Alert } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import QRGenerator from "../codereader/Qrgenerator";
import { useReactToPrint } from "react-to-print";
import Moment from 'moment';
import { cambioUbicacionSeriales, ObtenerDCargaPProduccion, ObtenerDInspeccionFPProduccion, ObtenerDPintadoPProduccion } from "../queries/DCUbicaciones";
import TimeField from "react-simple-timefield";
import { GetPProduccionGeneral, GetRecibaSerialesID } from "../queries/Queries";
//import { API } from "aws-amplify";
import { createPProduccionGeneral, createPProduccionUltimoNumero, updatePProduccionGeneral, updatePProduccionUltimoNumero, updateRecibaSeriales, updateRecibaSerialesMP } from "../../graphql/mutations";
import { listPProduccionUltimoNumeros } from "../../graphql/queries";
import { generateClient } from "aws-amplify/api";

const API = generateClient();

function CargaPintado({
  sProduccion,
  bColor,
  btitle,
  modulo,
  usuario,
  tipo,//Carga, CargaPlaneado, CargaPintado
  valorDeREtorno
}) {

  const [detallesCarga, setDetallesCarga] = useState([]);
  const [detallesPintado, setDetallesPintado] = useState([]);
  const [detallesInspeccionF, setDetallesInspeccionF] = useState([]);
  const [modalCP, setModalCP] = useState(false);
  const [cargando, setCargando] = useState(false);
  const toggleCP = () => setModalCP(!modalCP);
  const [piezasenCargando, setPiezasenCargando] = useState(sProduccion.piezasenAlmacen);
  const [rackCarga, setRackCarga] = useState(sProduccion.piezasXRack ?
    (parseFloat(sProduccion.piezasenAlmacen) / parseFloat(sProduccion.piezasXRack)).toFixed(2) : 0);
  const [numeroRackCarga, setnumeroRackCarga] = useState("");
  const [rackTipo, setRackTipo] = useState(sProduccion.rackTipo);
  const [cicloCarga, setCicloCarga] = useState(1);
  const [fecha, setfecha] = useState(new Date());
  const [idProduccionGeneral, setIDProduccionGeneral] = useState("");
  const [fechaCarga, setfechaCarga] = useState(Moment(fecha).format("YYYY-MM-DD"));
  const [fechaPintado, setfechaPintado] = useState(Moment(fecha).format("YYYY-MM-DD"));
  const [horaCarga, sethoraCarga] = useState(Moment(fecha).format("HH:mm"));
  const [horaPintado, sethoraPintado] = useState(Moment(fecha).format("HH:mm"));
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const [aVisible, setAVisible] = useState(false);
  const onDismiss = () => setAVisible(false);




  async function verCargaPintado(produccion) {
    setCargando(true);
    //valorDeREtorno("Mensaje de Carga e inspección");

    setPiezasenCargando(sProduccion.piezasenAlmacen)
    toggleCP();
    setCargando(false);
    setAVisible(false);

  }

  function handleInputChange(e, actual) {
    const { name, value } = e.target;
    var valor = actual;
    const re = /^[0-9\.]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      valor = e.target.value;
    }
    return valor
  }
  async function aceptarCargaPintado() {
    var resultado = { mensaje: "", color: "primary", completo: false, registros: {} };
    setAVisible(false);
    setCargando(true);
    setColor("warning");

    try {
      setMensajeAlert("Iniciando la carga: " + sProduccion.piezasenAlmacen);
      if (piezasenCargando > 0) {
        //Se revisa si la cantidad especificada en cargando no sea mayor a la cantidad del plan deproducción
        if (
          (piezasenCargando > sProduccion.piezasenAlmacen) || !rackCarga || !piezasenCargando) {
          window.scrollTo(0, 0);
          //Si es mayor se manda un mensaje
          setMensajeAlert("No fue posible realizar la operación: La cantidad en carga no puede ser mayor a la disponible para carga," +
            " el número de Racks y la Cantidad son obligatorios");
          setColor("warning");
          setCargando(false);
          setAVisible(true);
        } else {
          setMensajeAlert("Iniciando a revisar la concurrencia");
          var pConcurrencia = false;
          //Se obtienen los datos del plan de producción por número para revisar la concurrencia
          setMensajeAlert("Obteniendo los datos de producción, concurrencia");
          //Se obtienen los datos de  reciba seriales para revisar la concurrencia.
          const pProduccionFromAPI = await GetRecibaSerialesID(sProduccion.recibaSerialID); //.data.listPProduccions.items;
          setMensajeAlert("Datos obtenidos, concurrencia");
          //Si no existen datos, se considera que existe concurrencia
          if (!pProduccionFromAPI.id) {
            pConcurrencia = true;
            setMensajeAlert("Menor que 1");
          } else {
            //Si existen datos, se revisa si las fechas de actualización de los registros es la misma
            //Si no es la misma fecha de actualización de ambos registros, se considera que existe concurrencia
            if (
              pProduccionFromAPI.piezasenCarga !==
              sProduccion.piezasenCarga
            ) {
              pConcurrencia = true;
            }
          }
          setMensajeAlert("Concurrencia revisada");
          //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de piezasenCarga  en pProduccion
          //Además, se guarda la ubicación en Ubicaciones
          if (pConcurrencia === false) {
            //Se obtiene el registro más reciente del serial en el plan de producción, para revisar
            // concurrencia y el valor de terminado.
            var pproduccionGID = "";
            setMensajeAlert("Obteniendo datos; 1");
            const ppg = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaCarga } }, { activo: { eq: true } }] });
            setMensajeAlert("Obteniendo datos; 2");
            //Se actualiza el registro general de plan de producción.          
            if (ppg.length > 0) {
              pproduccionGID = ppg[0].id;
              const pproduccionG = ppg[0];
              const datoRepetido = pproduccionG.recibaSerialIDS ? await pproduccionG.recibaSerialIDS.filter(datosPProduccion =>
                datosPProduccion.includes(sProduccion.recibaSerialID)) : [];
              if (!datoRepetido[0]) {
                const brecibaSerialIDS = pproduccionG.recibaSerialIDS ?
                  [...pproduccionG.recibaSerialIDS, { id: sProduccion.recibaSerialID }] :
                  [{ id: sProduccion.recibaSerialID }];

                const rPProduccion = {
                  ...pproduccionG,
                  recibaSerialIDS: brecibaSerialIDS,
                  Reg_Mod_Usuario: usuario
                };

                delete rPProduccion.createdAt;
                delete rPProduccion.updatedAt;
                delete rPProduccion.__typename;
                setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion));
                await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
              }
            } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
              setMensajeAlert("Obteniendo datos; 3");
              var numeroUP = 1;
              const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
              const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
              await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                numeroUP = ultimaplaneacion.numero + 1;
                ultimaplaneacion.numero = numeroUP;

                delete ultimaplaneacion.createdAt;
                delete ultimaplaneacion.updatedAt;
                delete ultimaplaneacion.__typename;
                ultimaplaneacion.Reg_Mod_Usuario = usuario;
                await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                return ultimaplaneacion;
              }))
              if (!ultimapFromAPI.length) {
                await API.graphql({
                  query: createPProduccionUltimoNumero, variables: {
                    input: {
                      numero: numeroUP, activo: true, Reg_Ins_Usuario: usuario
                    }
                  }
                });
              }
              //Se crea el registro de la plan de producción general
              setMensajeAlert("Problemas al guardar la planeación general 1");
              let resulppg = await API.graphql({
                query: createPProduccionGeneral, variables: {
                  input: {
                    fechaDePlaneacion: fechaCarga,
                    numero: numeroUP,
                    espacioVacio: 0,
                    porSerial: true,
                    recibaSerialIDS: [{ id: sProduccion.recibaSerialID }],
                    activo: true,
                    Reg_Ins_Usuario: usuario
                  }
                }
              });
              pproduccionGID = resulppg.data.createPProduccionGeneral.id;
              setIDProduccionGeneral(pproduccionGID);
            }
            //Se obtienen los datos de la reciba seriales por ID
            const recibaFromAPI = pProduccionFromAPI;

            //Se asigna el valor de la fecha de la carga
            /*const fechacarga = Moment(new Date()).format("YYYY-MM-DD");
            const horacarga = Moment(new Date()).format("HH:mm");*/
            const fecha = Moment(new Date()).format("YYYY-MM-DD HH:mm");
            const fechahoracarga = Moment(fechaCarga + " " + horaCarga).format("YYYY-MM-DD HH:mm");
            const piezasfechayhora = piezasenCargando + " " + fechahoracarga;
            sProduccion.cargaFechaHora = !sProduccion.cargaFechaHora ?
              piezasfechayhora : sProduccion.cargaFechaHora + ", " + piezasfechayhora;

            sProduccion.pintadoFechaHora = !sProduccion.pintadoFechaHora ?
              piezasfechayhora : sProduccion.pintadoFechaHora + ", " + piezasfechayhora;

            //Creación o actualización de registro en pProducción   
            const datosCarga = {
              produccionGID: pproduccionGID, fechaDePlaneacion: fechaCarga,
              fecha: fechaCarga, hora: horaCarga, cantidadPiezas: piezasenCargando,
              materialEnCantidad: sProduccion.materialEnCantidad, racks: rackCarga,
              piezasenCarga: piezasenCargando, ciclos: cicloCarga,
              numeroRackCarga: numeroRackCarga ? numeroRackCarga : "", Reg_Ins_FH: fecha,
              Reg_Ins_Usuario: usuario, modulo: modulo, rackTipo: rackTipo
            }

            const datosPintado = {
              produccionGID: pproduccionGID, fechaDePlaneacion: fechaCarga,
              fecha: fechaPintado, hora: horaPintado, cantidadPiezas: piezasenCargando,
              piezasenPintado: piezasenCargando, racks: rackCarga, ciclos: cicloCarga,
              Reg_Ins_FH: fecha, Reg_Ins_Usuario: usuario, modulo: modulo
            }

            if (recibaFromAPI.id) {
              //Se cambia la ubicación del material de almacén a carga
              const loacionAnterior = "";
              const ubicacionAnterior = "Almacén";
              const loacionPiezas = "Carga";;
              const ubicacionPiezas = "Producción";
              const cantidadPiezas = piezasenCargando;
              var cambioUbicacionAux = [];
              setMensajeAlert("Antes de obtener los datos del cambio de ubicación 1");
              cambioUbicacionAux = await cambioUbicacionSeriales(
                recibaFromAPI,
                ubicacionAnterior,
                loacionAnterior,
                ubicacionPiezas,
                loacionPiezas,
                cantidadPiezas);
              setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux));
              if (cambioUbicacionAux.mensaje != "") {
                setMensajeAlert(cambioUbicacionAux.mensaje);
                setColor(cambioUbicacionAux.color);
                setCargando(false);
                setAVisible(true);
                return;
              } else {
                recibaFromAPI.ultimaUbicacion = await cambioUbicacionAux.sUltimaU;
                recibaFromAPI.rubicaciones = await cambioUbicacionAux.sUbicaciones
                if (tipo === "CargaPintado") {//Carga, CargaPlaneado, CargaPintado)
                  //Cambio de piezas a Pintado.
                  const loacionAnteriorp = "Carga";
                  const ubicacionAnteriorp = "Producción";
                  const loacionPiezasp = "Pintado";;
                  const ubicacionPiezasp = "Producción";
                  const cantidadPiezasp = piezasenCargando;
                  var cambioUbicacionAuxp = [];
                  setMensajeAlert("Antes de obtener los datos del cambio de ubicación 2" + JSON.stringify(recibaFromAPI));
                  cambioUbicacionAuxp = await cambioUbicacionSeriales(
                    //{ ...recibaFromAPI, ultimaUbicacion: cambioUbicacionAux.sUltimaU, rubicaciones: cambioUbicacionAux.sUbicaciones },
                    recibaFromAPI,
                    ubicacionAnteriorp,
                    loacionAnteriorp,
                    ubicacionPiezasp,
                    loacionPiezasp,
                    cantidadPiezasp,
                    true);
                  setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAuxp));
                  if (cambioUbicacionAuxp.mensaje != "") {
                    setCargando(false);
                    setAVisible(true);
                    return;
                  } else {
                    recibaFromAPI.ultimaUbicacion = cambioUbicacionAuxp.sUltimaU;
                    recibaFromAPI.rubicaciones = cambioUbicacionAuxp.sUbicaciones
                    setMensajeAlert("Ubicaciones agrupadas");
                  }
                  const datosPintandor = recibaFromAPI.registroPintado ? recibaFromAPI.registroPintado : [];
                  await datosPintandor.push(datosPintado);

                  recibaFromAPI.registroPintado = datosPintandor;
                  recibaFromAPI.pintadoFechaHora = sProduccion.pintadoFechaHora;
                  recibaFromAPI.piezasenPintado = !recibaFromAPI.piezasenPintado
                    ? piezasenCargando
                    : parseInt(recibaFromAPI.piezasenPintado) +
                    parseInt(piezasenCargando);
                }

                setMensajeAlert("Ubicaciones agrupadas");
              }
              //Se actualizan los datos de carga en reciba
              //Se actualiza el registro de carga
              const datosCargandor = recibaFromAPI.registroCarga ? recibaFromAPI.registroCarga : [];
              await datosCargandor.push(datosCarga);
              //Datos de plandeproducción
              recibaFromAPI.racks = parseFloat(recibaFromAPI.racks ? recibaFromAPI.racks : 0) + parseFloat(rackCarga);
              recibaFromAPI.ciclos = parseInt(recibaFromAPI.ciclos ? recibaFromAPI.ciclos : 0) + parseInt(cicloCarga);
              recibaFromAPI.ultimoRack = numeroRackCarga;
              recibaFromAPI.numeroCarga = (recibaFromAPI.numeroCarga ? recibaFromAPI.numeroCarga : 0) + 1;
              recibaFromAPI.registroCarga = datosCargandor;

              delete recibaFromAPI.createdAt;
              delete recibaFromAPI.updatedAt;
              delete recibaFromAPI.__typename;
              recibaFromAPI.piezasenCarga = !recibaFromAPI.piezasenCarga
                ? piezasenCargando
                : parseInt(recibaFromAPI.piezasenCarga) +
                parseInt(piezasenCargando);
              if (tipo != "CargaPlaneado") {
                recibaFromAPI.cantidadPlaneada = !recibaFromAPI.cantidadPlaneada
                  ? piezasenCargando
                  : parseInt(recibaFromAPI.cantidadPlaneada) +
                  parseInt(piezasenCargando);
              }
              if (modulo != "Producción") {
                recibaFromAPI.omitirCarga = false;
              }
              recibaFromAPI.piezasenAlmacen =
                recibaFromAPI.piezasenAlmacen - piezasenCargando;
              recibaFromAPI.cargaFechaHora = sProduccion.cargaFechaHora;
              recibaFromAPI.Reg_Mod_Usuario = usuario;
              let upRecibaS = await API.graphql({
                query: updateRecibaSeriales,
                variables: { input: recibaFromAPI },
              });
              //Se actualizan los datos en recibaSerialesMP
              const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
              if (recibaFromAPI.recibaSerialMPID) {
                delete recibaFromAPI.recibaSerialMPID;
                setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI));
                let upRecibaMP = await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                resultado.registros = upRecibaMP;
              }
            } else {
              setMensajeAlert("Operación errónea, no se encontraron registros de ubicación disponible");
              setColor("warning");
              setCargando(false);
              setAVisible(true);
              valorDeREtorno(resultado);
              return;
            }

            window.scrollTo(0, 0);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            resultado.completo = true;
            valorDeREtorno(resultado);
            setCargando(false);
            setAVisible(true);
            toggleCP();
            /* if (cargaCompleta === false) {
               fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
             }*/
            /*if (cargandoSinQR === false) {
              setTextBCarga("Terminar Carga");
            }*/
          } else {
            //Si  hay concurrencia se tienen que actualizar los datos
            window.scrollTo(0, 0);
            /*setMensajeAlert(
            "No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
              " volver a intentarlo"
            );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            //fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
          }
        }
      }
    } catch (e) {
      window.scrollTo(0, 0);
      /*setMensajeAlert(
        "No fue posible realizar la operación: revise su conexión a internet, recargue la página y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas"
      );*/
      setColor("warning");
      setCargando(false);
      setAVisible(true);
      valorDeREtorno(resultado);
    }
  }

  return (
    <>
      <Row>
        {/*cargando === true && (
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
            <img width="150px" src="assets/img/preloader.gif" />
          </div>
        )*/}
      </Row>
      {cargando === false && (
        <button
          class={"btn-" + bColor + " cbutton"}
          title={btitle}
          //style={{ display: "none" }}
          onClick={() => verCargaPintado(sProduccion)}
        >
          <IoIcons.IoMdCloudUpload />
        </button>
      )}
      <Modal isOpen={modalCP} toggle={toggleCP} >
        <ModalHeader toggle={toggleCP}>
          {btitle}
        </ModalHeader>
        <ModalBody>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Cliente</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                {sProduccion.cliente}
              </Label>
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Número de parte</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                {sProduccion.numerodeParte}
              </Label>
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Descripción</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                {sProduccion.descripcion}
              </Label>
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Serial</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                {sProduccion.serial}
              </Label>
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Serial BTI</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                {sProduccion.serialRecibaBTI}
              </Label>
            </div>
          </Row>
          {/*<Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Fecha  de carga</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                <Input name="fechaCarga"
                  value={Moment(fechaCarga).format("YYYY-MM-DD")}
                  type="date"
                  onChange={e => setfechaCarga(e.target.value)} />
              </Label>
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Hora de carga</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                <TimeField name="horaCarga"
                  className="w-100 custom-time"
                  value={horaCarga}
                  onChange={e => sethoraCarga(e.target.value)} />
              </Label>
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Fecha de pintado</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                <Input name="fechaPintado"
                  value={fechaPintado}
                  type="date"
                  onChange={e => setfechaPintado(e.target.value)} />
              </Label>
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Hora de pintado</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label>
                <TimeField name="horaPintado"
                  className="w-100 custom-time"
                  value={horaPintado}
                  onChange={e => sethoraPintado(e.target.value)} />
              </Label>
            </div>
          </Row>*/}
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className={(!piezasenCargando) ? "tbold fcolorred" : "tbold"}>Cantidad*</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Input
                name="piezasenCargando"
                maxLength={20}
                value={
                  piezasenCargando
                }
                onChange={(e) => setPiezasenCargando(handleInputChange(e, piezasenCargando))}
                placeholder=""
              />
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Número de Rack</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Input
                name="numeroRackCarga"
                maxLength={20}
                value={
                  numeroRackCarga
                }
                onChange={(e) =>
                  setnumeroRackCarga(handleInputChange(e, numeroRackCarga))
                }
                placeholder=""
              />
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Tipo de Rack</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <select
                name="rackTipo"
                className=" custom-select"
                onChange={(e) => setRackTipo(e.target.value)}
              >
                <option
                  value="" selected={rackTipo ? true : false}>
                </option>
                <option
                  value="Movible" selected={rackTipo === "Movible" ? true : false}>Movible
                </option>
                <option
                  value="Fijo" selected={rackTipo === "Fijo" ? true : false}>Fijo
                </option>
              </select>

            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className={(!rackCarga) ? "tbold fcolorred" : "tbold"}>Racks*</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Input
                name="rackCarga"
                maxLength={20}
                value={rackCarga}
                onChange={(e) => setRackCarga(handleInputChange(e, rackCarga))}
                placeholder=""
              />
            </div>
          </Row>
          <Row>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <Label className="tbold">Ciclo</Label>
            </div>
            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
              <select
                name="cicloCarga"
                className=" custom-select"
                onChange={(e) => setCicloCarga(handleInputChange(e, cicloCarga))}
              >
                <option
                  value="1"
                  selected={cicloCarga === 1
                    ? true
                    : false
                  }
                >
                  1
                </option>
                <option
                  value="2"
                  selected={
                    sProduccion.cicloCarga === 2
                      ? true
                      : false
                  }
                >
                  2
                </option>
                <option
                  value="3"
                  selected={
                    sProduccion.cicloCarga === 3
                      ? true
                      : false
                  }
                >
                  3
                </option>
                <option
                  value="4"
                  selected={
                    sProduccion.cicloCarga === 4
                      ? true
                      : false
                  }
                >
                  4
                </option>
                <option
                  value="5"
                  selected={
                    sProduccion.cicloCarga === 5
                      ? true
                      : false
                  }
                >
                  5
                </option>
                <option
                  value="6"
                  selected={
                    sProduccion.cicloCarga === 6
                      ? true
                      : false
                  }
                >
                  6
                </option>
                <option
                  value="7"
                  selected={
                    sProduccion.cicloCarga === 7
                      ? true
                      : false
                  }
                >
                  7
                </option>
                <option
                  value="8"
                  selected={
                    sProduccion.cicloCarga === 8
                      ? true
                      : false
                  }
                >
                  8
                </option>
                <option
                  value="9"
                  selected={
                    sProduccion.cicloCarga === 9
                      ? true
                      : false
                  }
                >
                  9
                </option>
                <option
                  value="10"
                  selected={
                    sProduccion.cicloCarga ===
                      10
                      ? true
                      : false
                  }
                >
                  10
                </option>
                <option
                  value="11"
                  selected={
                    sProduccion.cicloCarga ===
                      11
                      ? true
                      : false
                  }
                >
                  11
                </option>
                <option
                  value="12"
                  selected={
                    sProduccion.cicloCarga ===
                      12
                      ? true
                      : false
                  }
                >
                  12
                </option>
                <option
                  value="13"
                  selected={
                    sProduccion.cicloCarga ===
                      13
                      ? true
                      : false
                  }
                >
                  13
                </option>
                <option
                  value="14"
                  selected={
                    sProduccion.cicloCarga ===
                      14
                      ? true
                      : false
                  }
                >
                  14
                </option>
                <option
                  value="15"
                  selected={
                    sProduccion.cicloCarga ===
                      15
                      ? true
                      : false
                  }
                >
                  15
                </option>
                <option
                  value="16"
                  selected={
                    sProduccion.cicloCarga ===
                      16
                      ? true
                      : false
                  }
                >
                  16
                </option>
              </select>
            </div>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                {mensajeAlert}
              </Alert>
            </div>
          </Row>
          {cargando === true && (
            <img width="150px" src="assets/img/preloader.gif" />
          )}
          {cargando === false && (
            <Button
              color="primary"
              onClick={aceptarCargaPintado}
            >
              Aceptar
            </Button>
          )}
          <Button color="danger" onClick={toggleCP}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default CargaPintado;
